<template>
	<div class="block-wrap">
		<div class="box-wrap">
			<div class="block-title">
				<h3>组织机构</h3>
				<div class="pagi" v-if="list.length > 4">
					<div class="button-prev" :class="timelineActive === 3 ? 'disable' : ''" @click="onTimelinePrev"></div>
					<div class="button-next" :class="timelineActive === list.length - 1 ? 'disable' : ''" @click="onTimelineNext"></div>
				</div>
			</div>
			<div class="content-wrap">
				<div class="timeline-wrap" :style="timelineStyle">
					<div class="item-card hand" @click="toDetail(item)" v-for="(item, idx) in list" :key="idx">
						<img class="card-img" :src="item.coverImg || tempImage" alt="" />
						<div class="card-info">
							<h4 class="card-title">{{item.institutionTitle}}</h4>
							<div class="card-detail">{{item.briefIntroduction}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<SplitLine />
	</div>
</template>

<script>
import tempImage from '@/assets/images/about-us-org.jpg';
import router from '@/router';
export default {
	data() {
		return {
			tempImage,
			timelineActive: 3,
			timelineStyle: ''
		}
	},
	props: {
		list: {
			type: Array,
			default() {
				return []
			}
		}
	},
	methods: {
		onTimelinePrev() {
			const idx = this.timelineActive;
			if (idx === 3) return;
			this.timelineActive = idx - 1;
			this.onTimelineChange();
		},
		onTimelineNext() {
			const idx = this.timelineActive;
			if (idx === this.list.length - 1) return;
			this.timelineActive = idx + 1;
			this.onTimelineChange();
		},
		onTimelineChange() {
			const idx = this.timelineActive;
			const listLenth = this.list.length;
			if (listLenth <= 4) return;
			if (idx <= 3) {
				this.timelineStyle = 'left: 0';
			} else if (idx > 3 && idx <= listLenth - 1) {
				this.timelineStyle = `left: -${(idx - 3) * 295}px`;
			}
		},
		toDetail(item) {
			router.push(`/aboutus/institution/detail?aId=${item.id}`);
		}
	}
}
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';

.box-wrap {
	position: relative;
	padding: 30px 0 20px 40px;

	&::before {
		content: '';
		width: 250px;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		background: #06AE63;
		z-index: -1;
	}
}
.block-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 20px;

	h3 {
		font-size: 32px;
		font-family: PingFang SC;
		font-weight: 800;
		color: #FFFFFF;
		margin-right: 20px;
	}
	
	.pagi {
		height: 30px;
		display: flex;
		justify-content: flex-end;
	
		> div {
			width: 30px;
			height: 100%;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			cursor: pointer;
	
			&.button-prev {
				background-image: url(../../assets/images/active-prev.png);
				margin-right: 20px;
	
				&.disable {
					background-image: url(../../assets/images/active-prev-disable.png);
				}
			}
	
			&.button-next {
				background-image: url(../../assets/images/active-next.png);
				margin-right: 20px;
	
				&.disable {
					background-image: url(../../assets/images/active-next-disable.png);
				}
			}
		}
	}
}
.content-wrap {
  width: 100%;
  height: 314px;
  position: relative;
  overflow: hidden;

  .timeline-wrap {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
		transition: left .8s ease-in-out;

		.item-card {
			width: 275px;
			margin-right: 20px;
		
			.card-img {
				display: block;
				width: 100%;
				height: 164px;
			}
		
			.card-info {
				width: 100%;
				height: 150px;
				background: #FDFFFD;
				border: 1px solid #E1E1E1;
				padding: 20px;
				padding-bottom: 30px;
		
				.card-title {
					&:extend(.line1);
					font-size: 18px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 600;
					color: #131415;
					line-height: 36px;
					margin-bottom: 5px;
				}
		
				.card-detail {
					&:extend(.line3);
					font-size: 12px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #9D9E9E;
					line-height: 20px;
				}
			}
		}  
	}
}
</style>